// ─── AI 관리자 이력 조회 커스텀 훅 ──────────────────────────────────────────
import { useQuery } from '@tanstack/react-query';
import { adminHistoryQueryKey, fetchCompanyHistory } from '../utils/dataHelpers';

/**
 * 사업장 전체 AI 질의 이력을 가져오는 React Query 훅.
 * @returns {{ rows, isLoading, isError, error, refetch, isFetching }}
 */
export function useAdminHistory() {
  const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
    queryKey: adminHistoryQueryKey(),
    queryFn:  fetchCompanyHistory,
    staleTime: 60 * 1000,
    retry: 1,
  });

  return {
    rows: Array.isArray(data) ? data : [],
    isLoading,
    isError,
    error,
    refetch,
    isFetching,
  };
}
